import { useCallback } from "react";

export const useTracking = () => {
  const trackEvent = useCallback((eventName, payload) => {
    // Aseguramos que el dataLayer exista (buena práctica)
    window.dataLayer = window.dataLayer || [];

    // Empujamos el evento a GTM
    window.dataLayer.push({
      event: eventName,
      ...payload
    });

    // Opcional: Console.log para debuguear en desarrollo
    if (import.meta.env.DEV) {
      console.log(`[Tracking] ${eventName}`, payload);
    }
  }, []);

  return { trackEvent };
};
